/* Conspiracy Den — Exit Intent Email Capture
   Triggers when mouse exits viewport toward top.
   Uses Shopify customer form endpoint.
   Respects: session storage (shown once per session), 
             cookie (never show again after subscribe).
   No third-party deps.
*/

(function() {
  'use strict';

  var COOKIE_NAME = 'cd_sub';
  var SESSION_KEY = 'cd_popup_shown';
  var DELAY_MS    = 3000; // don't trigger in first 3s
  var ready       = false;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function shouldShow() {
    if (getCookie(COOKIE_NAME)) return false;
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    return true;
  }

  function buildPopup() {
    var overlay = document.createElement('div');
    overlay.id = 'cd-exit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Get first access to the next file');
    overlay.innerHTML = [
      '<div id="cd-exit-popup">',
        '<button id="cd-exit-close" aria-label="Close">&times;</button>',
        '<div class="cd-popup-eyebrow">CLASSIFIED</div>',
        '<h2 class="cd-popup-headline">The next file drops before it goes public.</h2>',
        '<p class="cd-popup-subtext">First-look access, drop alerts, and the research behind the merch. No newsletters. No noise.</p>',
        '<form id="cd-exit-form" novalidate>',
          '<div class="cd-field-wrap">',
            '<input id="cd-exit-email" type="email" name="contact[email]" placeholder="your@email.com" required autocomplete="email" />',
            '<input type="hidden" name="contact[tags]" value="newsletter,exit-popup" />',
            '<input type="hidden" name="form_type" value="customer" />',
            '<input type="hidden" name="utf8" value="\u2713" />',
          '</div>',
          '<button type="submit" id="cd-exit-submit">Open the file</button>',
        '</form>',
        '<div id="cd-exit-success" style="display:none;">',
          '<p class="cd-success-msg">You\'re in. Watch for the next drop.</p>',
        '</div>',
        '<p class="cd-popup-legal">No spam. Unsubscribe anytime.</p>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);
    return overlay;
  }

  function injectStyles() {
    var css = [
      '#cd-exit-overlay{',
        'position:fixed;inset:0;z-index:9999;',
        'background:rgba(0,0,0,0.82);',
        'display:flex;align-items:center;justify-content:center;',
        'padding:20px;box-sizing:border-box;',
        'animation:cdFadeIn 0.25s ease;',
      '}',
      '@keyframes cdFadeIn{from{opacity:0}to{opacity:1}}',
      '#cd-exit-popup{',
        'background:#0d0d0d;color:#e8e8e0;',
        'border:1px solid #333;',
        'max-width:440px;width:100%;',
        'padding:40px 36px 32px;',
        'position:relative;',
        'font-family:inherit;',
        'box-shadow:0 0 60px rgba(0,0,0,0.6);',
      '}',
      '#cd-exit-close{',
        'position:absolute;top:14px;right:16px;',
        'background:none;border:none;color:#666;',
        'font-size:22px;cursor:pointer;line-height:1;',
        'padding:4px 8px;',
      '}',
      '#cd-exit-close:hover{color:#e8e8e0;}',
      '.cd-popup-eyebrow{',
        'font-size:11px;letter-spacing:0.18em;',
        'color:#666;margin-bottom:14px;',
        'font-weight:600;',
      '}',
      '.cd-popup-headline{',
        'font-size:22px;line-height:1.25;',
        'margin:0 0 12px;color:#e8e8e0;font-weight:700;',
      '}',
      '.cd-popup-subtext{',
        'font-size:14px;color:#999;',
        'line-height:1.5;margin:0 0 24px;',
      '}',
      '.cd-field-wrap{margin-bottom:12px;}',
      '#cd-exit-email{',
        'width:100%;box-sizing:border-box;',
        'background:#1a1a1a;border:1px solid #333;',
        'color:#e8e8e0;padding:12px 14px;',
        'font-size:15px;outline:none;',
      '}',
      '#cd-exit-email:focus{border-color:#666;}',
      '#cd-exit-email::placeholder{color:#555;}',
      '#cd-exit-submit{',
        'width:100%;padding:13px;',
        'background:#e8e8e0;color:#0d0d0d;',
        'border:none;font-size:14px;font-weight:700;',
        'letter-spacing:0.06em;cursor:pointer;',
        'text-transform:uppercase;',
      '}',
      '#cd-exit-submit:hover{background:#fff;}',
      '.cd-popup-legal{',
        'font-size:11px;color:#555;',
        'margin:16px 0 0;text-align:center;',
      '}',
      '.cd-success-msg{',
        'font-size:16px;color:#c8c8c0;',
        'text-align:center;padding:20px 0;',
      '}',
      '@media(max-width:480px){',
        '#cd-exit-popup{padding:30px 20px 24px;}',
        '.cd-popup-headline{font-size:18px;}',
      '}'
    ].join('');
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function showPopup() {
    if (!shouldShow()) return;
    sessionStorage.setItem(SESSION_KEY, '1');

    injectStyles();
    var overlay = buildPopup();

    function close() {
      overlay.style.animation = 'cdFadeIn 0.15s ease reverse';
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 150);
    }

    document.getElementById('cd-exit-close').addEventListener('click', close);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    }, { once: true });

    document.getElementById('cd-exit-form').addEventListener('submit', function(e) {
      e.preventDefault();
      var email = document.getElementById('cd-exit-email').value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        document.getElementById('cd-exit-email').style.borderColor = '#c0392b';
        return;
      }

      var btn = document.getElementById('cd-exit-submit');
      btn.textContent = 'Filing...';
      btn.disabled = true;

      // Submit to Shopify customer form endpoint
      var formData = new FormData(this);
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function() {
        setCookie(COOKIE_NAME, '1', 365);
        document.getElementById('cd-exit-form').style.display = 'none';
        document.getElementById('cd-exit-success').style.display = 'block';
        setTimeout(close, 2800);
      }).catch(function() {
        // Fallback: try the newsletter form route
        var params = new URLSearchParams();
        params.append('contact[email]', email);
        params.append('contact[tags]', 'newsletter,exit-popup');
        params.append('form_type', 'customer');
        params.append('utf8', '\u2713');
        fetch('/?form_type=customer&utf8=\u2713', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: params.toString()
        }).then(function() {
          setCookie(COOKIE_NAME, '1', 365);
          document.getElementById('cd-exit-form').style.display = 'none';
          document.getElementById('cd-exit-success').style.display = 'block';
          setTimeout(close, 2800);
        });
      });
    });
  }

  // Exit intent detection: mouse leaves toward top of viewport
  function initExitIntent() {
    var triggered = false;
    document.addEventListener('mouseleave', function(e) {
      if (triggered) return;
      if (e.clientY <= 20) {
        triggered = true;
        showPopup();
      }
    });

    // Mobile fallback: show after 45s of engagement
    var mobileTimer;
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      mobileTimer = setTimeout(function() {
        if (!triggered) {
          triggered = true;
          showPopup();
        }
      }, 45000);
    }
  }

  // Wait for DOM + delay before arming
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() { ready = true; initExitIntent(); }, DELAY_MS);
    });
  } else {
    setTimeout(function() { ready = true; initExitIntent(); }, DELAY_MS);
  }

})();
